<template>
    <main id="main" class="main-site">
        <div class="container">
            <div class="wrap-breadcrumb">
                <ul>
                    <li class="item-link"><router-link to="/loja" class="fa fa-home"></router-link></li>
                    <li class="item-link"><span>Gerar Contrato</span></li>
                </ul>
            </div>
            <div class="main-content-area">
                <div>
                    <h2>Falta pouco para que você possa se tornar uma Revenda da Aldo!</h2>

                    <div class="row">
                        <div class="col-md-12">
                            <ul class="obs">
                                <li>Confira abaixo o passo a passo para efetivação final do seu cadastro:</li>
                                <li>A assinatura do contrato só pode ser feita por apenas 1(um) sócio da empresa, caso possua mais de um sócio deverá selecionar qual sócio irá assinar</li>
                                <li>Para assinar o contrato, informe o CNPJ da sua revenda, clique em <b>AVANÇAR</b> e selecione qual sócio irá assinar o contrato</li>
                                <li>Caso não consiga assinar devido a pendência de documentos no cadastro, utilize a ferramenta de envio de documentos para enviar o Contrato Social ou Certificado MEI, para acessar o manual da ferramenta
                                    <a rel="nofollow" class="link-term" target="_blank" href="/arquivos/manual-upload-documentos.pdf"><span class="desc"><b>CLIQUE AQUI</b></span></a>
                                    </li>                                                                                                                                
                                <li>Caso o sócio não tenha a data de nascimento e/ou e-mail em seu cadastro, será solicitado ao Gerar o Contrato de Revendas</li>   
                                <li>Clique no botão abaixo <b>GERAR CONTRATO</b>.</li>                                                                  
                                <li>Caso tenha dúvidas, entre em contato conosco pelo e-mail: <a href="mailto:cadastro@aldo.com.br">cadastro@aldo.com.br</a></li>
                                <br/>
                                <p>Finalizada a assinatura do contrato, o seu acesso está validado e já será possível se conectar na área de clientes, onde terá acesso aos preços e vantagens exclusivas para revendas Aldo.</p>
                            </ul>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                            <div class="register-form form-item ">
                                <form @submit.prevent="register" name="frm-login" method="get">

                                    <div class="row" v-if="!loadCNPJ">
                                        <div class="col-md-6">
                                            <FormHelper :inputVar="formRegister.cnpj" :form="formRegister" validationType="cnpj" label="CNPJ" mask="##.###.###/####-##"></FormHelper>
                                        </div>
                                        <div v-if="loadingCnpj" class="col-md-6">
                                            <Loader style="margin-top: 20px;" />
                                        </div>                                        
                                    </div>
                                    <!-- <input v-if="!loadCNPJ" type="button" class="btn btn-sign" style="background-color:#021746;color:white" v-on:click="InfoCNPJ()" :codRevenda="codRevenda" value="Avançar" name="sign"> -->
                                    <button v-if="!loadCNPJ" aria-label="Voltar" class="btn primary-button" type="submit" v-on:click="InfoCNPJ()">Avançar <i class="fa fa-arrow-right"></i></button>                                    
                                    <button v-if="loadCNPJ" aria-label="Voltar" class="btn primary-button" type="submit" v-on:click="Voltar()"><i class="fa fa-arrow-left"></i> Voltar</button>
                                    <div class="row" v-if="loadCNPJ">                                        
                                         <div class="row">
                                            <div class="col-md-12">
                                                <h3 class="box-title">Utilize a ferramenta abaixo para realizar o envio e aconpanhar o status dos documentos enviados:</h3>
                                            </div>
                                        </div>
                                        <div class="linha" style="margin: 10px;">
                                            <BulmaAccordion :dropdown="false" :icon="'custom' ">
                                                    <BulmaAccordionItem>
                                                        <h4 slot="title">Enviar documentos</h4>
                                                        <div slot="content">
                                                            <SendDocuments />
                                                        </div>
                                                    </BulmaAccordionItem>
                                            </BulmaAccordion>
                                        </div>
                                        <!-- Dados da Empresa -->
                                        <div class="row">
                                            <div class="col-md-12">
                                                <h3 class="box-title">Dados da Empresa</h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <FormHelper :inputVar="formRegister.razaoSocial" :form="formRegister" maxlength="60" label="Razão Social" :disabled="true"></FormHelper>
                                            </div>
                                            <div class="col-md-6">
                                                <FormHelper :inputVar="formRegister.nomeFantasia" :form="formRegister" validationType="quotes" maxlength="60" label="Nome Fantasia" :disabled="true"></FormHelper>
                                            </div>
                                        </div>
                                        <div class="col-md-12" v-if="token_cliente == '' && loadGerarContrato">                                        
                                            <table class="table table-striped custab">                                                
                                                <div>
                                                    <h3 class="box-title">Selecione o sócio</h3>
                                                    <h2 style=" font-size: 15px; margin-top: -5px; margin-bottom: 20px;">Sua empresa possui mais de um sócio cadastrado, somente um sócio poderá assinar o contrato</h2>
                                                </div>                                                
                                                <label v-for="(name, index) in lstSocios" :key="index" class="inline-radio col-md-12">                                                                                                           
                                                <input
                                                    class="col-md-1"
                                                    type="radio"                                                            
                                                    style="width: 22px;"
                                                    :value="name"  
                                                    v-model="socioSelecionado" 
                                                    v-on:change="selecionarSocio(name)" 
                                                    name="rdbsocio"
                                                />    
                                                <span class="col-md-6">{{ name.split('/')[0] }}</span>
                                            </label>
                                            </table>

                                        </div>
                                    </div>
                                    <div class="row">
                                        <div v-if="token_cliente !== ''">
                                            <iframe style="height: 600px; width: 100%"
                                                    frameborder="0"
                                                    v-bind:src="token_cliente"></iframe>
                                            <div class="col-md-12"
                                                 style="
                        font-size: 18px;
                        font-weight: bolder;
                        padding-top: 15px;
                        text-align: center;
                        color: #d11;
                      ">
                                                <p>
                                                    Ao concluir a assinatura faça o logout e login novamente
                                                    para que as crendenciais para o contrato comercial com revenda sejam
                                                    validadas.
                                                </p>
                                            </div>
                                        </div>
                                        <div v-if="permissaoGerarContrato"
                                             class="col-xs-12 col-sm-12">
                                            <button v-if="loadCNPJ && loadGerarContrato"
                                                    v-show="atualizouEmail"
                                                    class="btn primary-button"
                                                    :disabled="loadingContratoVD"
                                                    v-on:click="gerarContrato()"
                                                    aria-label="Gerar Contrato"><i class="fa fa-file-text"></i>
                                                 Gerar Contrato
                                            </button>
                                            <div v-if="loadingContratoVD">
                                                <Loader style="margin-top: 20px" />
                                            </div>
                                        </div>
                                    </div>

                                </form>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>

    </main>
</template>

<script>
    import axios from 'axios';
    import FormHelper from './partials/FormHelper.vue'
    import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";    
    import SendDocuments from "./partials/my-account/SendDocuments.vue";    
    export default {        
        components: {
            FormHelper,
            BulmaAccordion,
            BulmaAccordionItem,            
            SendDocuments,
        },   
    data() {
    return {
      socioSelecionado: null, 
      lstSocios: [],
        };
    },         
        name: 'GerarContrato',
        data() {
            return {
                codRevenda:"",
                loadingCnpj: false,
                token_cliente: "",
                loadCNPJ: false,
                loadGerarContrato: true,
                permissaoGerarContrato: false,
                loadingContratoVD: false,
                nameSocio: '',
                loadContratoVendaDireta: false,
                lstSocios: [],
                loadContratoVendaDiretaAssinado: false,
                formRegister: {
                    cnpj: new this.$formInput(),
                    razaoSocial: new this.$formInput(),
                    nomeFantasia: new this.$formInput(false)
                },
                atualizouEmail: false
            }
        },        
        mounted() {            
            if (sessionStorage.getItem('cnpj') !== null) {
                this.formRegister.cnpj.value = sessionStorage.getItem('cnpj');
                this.InfoCNPJ();
            }
        },
        computed: {
            isCnpjValid: function () {
                const re = /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})/;
                const cnpj = this.formRegister.cnpj;
                let response = {};
                if (!cnpj || !re.test(cnpj) || !this.testCnpj(cnpj)) {
                    response.status = false;
                    response.message = "Por favor, preencha o CNPJ corretamente"
                } else {
                    response.status = true;
                }
                return response;
            }

        },
        methods: {
            selecionarSocio: async function (socio) {
                const self = this;
                self.nameSocio = socio;
                const cliente = self.codRevenda;
                const cpfSocio = socio.split('/')[1] ? socio.split('/')[1].trim().replace(/\D/g, "") : "";

                const email = await swal({
                    title: "Preencher E-mail do Sócio: ",
                    icon: "info",
                    text: `
                        ${socio.split('/')[0].trim()}
                        \r\n\nSe o sócio informado não for o que irá realizar a assinatura, entre em contato com seu vendedor para alteração!
                    `,
                    content: "input",
                    buttons: true,
                });

                if (self.validateEmail(email)) {
                    try {
                        this.loadingContratoVD = true;
                        const response = await axios({
                            method: "POST",
                            url: this.$apiUrl + "Cliente.svc/atualizarEmailSocio",
                            withCredentials: true,
                            data: {
                                codigoCliente: cliente,
                                email: email,
                                cpf_socio: cpfSocio, // Agora enviando o CPF correto do sócio selecionado
                            },
                            contentType: "application/json",
                            dataType: "json",
                        });

                        const result = JSON.parse(response.data);
                        swal({
                            title: "E-mail atualizado com sucesso!",
                            text: result.message || "O e-mail foi salvo com sucesso.",
                            icon: "success",
                        });

                        self.atualizouEmail = true;
                    } catch (error) {
                        swal({
                            title: "Erro ao atualizar e-mail",
                            text: (error.response && error.response.data && error.response.data.message) 
                                || "Não foi possível atualizar o e-mail. Por favor, tente novamente.",
                            icon: "error",
                        });
                    } finally {
                        this.loadingContratoVD = false;
                    }
                } else {
                    swal({
                        title: "E-mail Inválido",
                        text: email || "Por favor, insira um e-mail válido.",
                        icon: "warning",
                    });
                }
            },
            async gerarContrato() {
                try {
                    this.loadingContratoVD = true;
                    let returnresult = await this.gerarContratoRevenda("", "");
                    var self = this;
                    if (returnresult.nome === "") {
                        this.loadingContratoVD = false;
                        swal({
                            title: "Sua empresa não possui sócios no cadastro da Aldo ",
                            icon: "info",
                            text: "Faça upload do Contrato social e Documentos dos sócios através da ferramenta de Envio de documentos. \n A ALDO fará o cadastramento dos sócios em até 1 dia útil, e então você já conseguirá gerar o contrato. \n Você pode acompanhar o status através da ferramenta de envio de documentos !"
                        });
                    }
                    else {
                        this.loadingContratoVD = false;
                            
                        if (returnresult.mensagem == "Data de Nascimento é Obrigatória") {
                            this.loadingContratoVD = false;
                            swal({
                                title: "Preencher Data de Nascimento do Sócio: ",
                                icon: "info",
                                text:
                                    returnresult.nome +
                                    " \r\n\nSe o sócio informado não for o que irá realizar a assinatura entre em contato com seu vendedor para alteração !",
                                content: {
                                    element: "input",
                                    attributes: {
                                        placeholder: "01/01/1980"
                                    }
                                },
                                showCloseButton: true,
                                showCancelButton: true,
                                focusConfirm: false,
                            }).then((value) => {
                                if (self.validateDate(value)) {
                                    this.loadingContratoVD = true;
                                    this.gerarContratoRevenda(value, 'DataNascimento');

                                } else
                                    swal({
                                        title: "Data de Nascimento Inválida",
                                        text: "Favor preencher no formato DD/MM/AAAA\n\n" + value,
                                        icon: "warning",
                                    });
                            });
                        }
                        if (returnresult.mensagem = '') {
                            swal({
                                title: returnresult.mensagem,
                                icon: "info",
                            }).then(() => (location.href = window.location.href));
                        }
                    }


                } catch (err) {
                } finally {
                    this.loadingContratoVD = false;
                }
            },
            async DownloadContrato() {
                return await axios({
                    method: "GET",
                    url: this.$apiUrl + "Cliente.svc/getcontratorevendas",
                    withCredentials: true,
                    responseType: 'blob',
                }).then((response) => {
                    let session = JSON.parse(localStorage.getItem('usuarioLogado'));
                    var namefile = "CONTRATO_REVENDA_" + session.DadosCliente.CliCodigo.toString();
                    var namefile = namefile + ".pdf";
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', namefile);
                    document.body.appendChild(link);
                    link.click();
                });
            },
            validateEmail(email) {
                const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            validateDate(email) {
                const re = /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
                return re.test(email);
            },
            async gerarContratoRevenda(_pparametro, _tpparametro) {
                var pcnpj = self.formRegister.cnpj.value;
                var pnomesocio = self.nameSocio;
                return await axios({
                    method: "POST",
                    url: this.$apiUrl + "Cliente.svc/gerarDocumentoRevendasCNPJ",
                    withCredentials: true,
                    data: { cnpj: pcnpj, parametro: _pparametro, tpParametro: _tpparametro, cpf_socio: pnomesocio },
                    contentType: "application/json",
                    dataType: "json",

                }).then((response) => {
                    let result = JSON.parse(response.data);
                    if (result != "E-mail é Obrigatório") {
                        swal({
                            title: result.mensagem,
                            icon: "success",
                        }).then((resultmsg) => {
                            if (result.mensagem !== 'Atualizado com Sucesso') {
                                location.href = window.location.href;
                            }
                            else {
                                this.gerarContrato();
                            }
                        });
                    }
                    return result;
                });
            },
            async gerarContratoRevenda(_pparametro, _tpparametro) {
                var pcnpj = self.formRegister.cnpj.value;
                var pnomesocio = self.nameSocio;
                return await axios({
                    method: "POST",
                    url: this.$apiUrl + "Cliente.svc/gerarDocumentoRevendasCNPJ",
                    withCredentials: true,
                    data: { cnpj: pcnpj, parametro: _pparametro, tpParametro: _tpparametro, cpf_socio: pnomesocio },
                    contentType: "application/json",
                    dataType: "json",
                    
                }).then((response) => {
                    let result = JSON.parse(response.data);
                    if (result != "E-mail é Obrigatório") {
                        swal({
                            title: result.mensagem,
                            icon: "success",
                        }).then((resultmsg) => {
                            if (result.mensagem !== 'Atualizado com Sucesso') {
                                location.href = window.location.href;
                            }
                            else {
                                this.gerarContrato();
                            }
                        });
                    }
                    return result;
                });
            },
            async atualizarEmail(codigoCliente, email, cpfSocio) {
                return await axios({
                    method: "POST",
                    url: this.$apiUrl + "Cliente.svc/atualizarEmailSocio",
                    withCredentials: true,
                    data: { codigoCliente, email, cpfSocio},
                    contentType: "application/json",
                    dataType: "json",
                    
                }).then((response) => {
                    let result = JSON.parse(response.data);
                    
                    return result;
                });
            },
            loadGerarContratoBackEnd(pcnpj) {
                self = this;
                return axios({
                    method: "POST",
                    url: this.$apiUrl + "Cliente.svc/getclientecontratorevendasCNPJ",
                    data: { cnpj: pcnpj },
                    contentType: "application/json",
                    withCredentials: true,
                    dataType: "json",
                }).then((response) => {
                    let loadContratoVendaDiretaParam = response.data;
                    if (loadContratoVendaDiretaParam == "GERARCONTRATO") {
                        self.permissaoGerarContrato = true;
                        self.loadContratoVendaDireta = true;
                        self.token_cliente = '';
                    } else if (loadContratoVendaDiretaParam == "NAOPERMITIR" || loadContratoVendaDiretaParam == "FALHA") {
                        self.loadContratoVendaDireta = false;
                        self.token_cliente = '';
                    } else if (loadContratoVendaDiretaParam == "CONTRATOGERADO") {
                        self.loadContratoVendaDiretaAssinado = true;
                        self.token_cliente = '';
                    } else {
                        self.token_cliente = "https://www.aldo.com.br/OldSite/Asp.Net/assinaturas/Default.htm?token=" + loadContratoVendaDiretaParam;
                        self.loadContratoVendaDireta = true;
                    }


                });
            },
            async Voltar(){
                const self = this;
                self.loadCNPJ = false;
                self.loadGerarContrato = true;
                self.loadingCnpj = false;
                self.token_cliente = "";
                self.codRevenda = "";
                self.permissaoGerarContrato = false;
                self.loadingContratoVD = false;
                self.nameSocio = '';
                self.loadContratoVendaDireta = false;
                self.lstSocios = [];
                self.loadContratoVendaDiretaAssinado = false;
            },
            async InfoCNPJ() {
                const self = this;
                let parametrocnpj = self.formRegister.cnpj.value;
                try {
                    parametrocnpj = self.formRegister.cnpj.value.toUpperCase();
                    return await axios({
                        method: "POST",
                        url: this.$apiUrl + "Cliente.svc/getinfocnpj",
                        data: { cnpj: parametrocnpj },
                        contentType: "application/json",
                        withCredentials: true,
                        dataType: "json",
                    }).then((response) => {
                        if (response.data.Item1 !== '') {
                            if (response.data.Item3.length == 0) {
                                const el = document.createElement('div')
                                el.innerHTML = "<a href='/arquivos/manual-upload-documentos.pdf' target='blank' >CLIQUE AQUI, para acessar o manual da ferramenta</a>"
                                swal({
                                    title: "Sua empresa não possui sócios no cadastro da Aldo ",
                                    icon: "info",
                                    text: "Faça upload do Contrato social ou Certificado MEI através da ferramenta de Envio de documentos." + 
                                            "\n\n A ALDO fará o cadastramento dos sócios em até 1 dia útil, e então você já conseguirá gerar o contrato."+ 
                                            "\n\n Utilize a ferramenta para acompanhar o status da documentação enviada.",
                                    content: el                                            
                                    
                                });                               

                                sessionStorage.setItem('cnpj', parametrocnpj);
                                self.formRegister.razaoSocial.value = response.data.Item1;
                                self.formRegister.nomeFantasia.value = response.data.Item2;                            
                                self.loadCNPJ = true;
                                self.loadGerarContrato = false;
                                self.lstSocios = response.data.Item3;                            
                                self.codRevenda = response.data.Item5;
                                self.loadGerarContratoBackEnd(parametrocnpj);
                                return;
                            }
                            if (response.data.Item4 !== parametrocnpj) {
                                swal({
                                    title: "Para assinar o contrato é necessário utilizar a Matriz.",
                                    icon: "info",
                                    text: "Para assinar o contrato é necessário utilizar a Matriz."
                                });
                                parametrocnpj = response.data.Item4;
                                self.formRegister.cnpj.value = parametrocnpj;
                            }
                            
                            sessionStorage.setItem('cnpj', parametrocnpj);
                            self.formRegister.razaoSocial.value = response.data.Item1;
                            self.formRegister.nomeFantasia.value = response.data.Item2;                            
                            self.loadCNPJ = true;
                            self.lstSocios = response.data.Item3;                            
                            self.codRevenda = response.data.Item5;
                            self.loadGerarContratoBackEnd(parametrocnpj);
                        }
                        else {
                            swal({
                                title: 'CNPJ inválido ou não encontrado',
                                icon: "error",
                            }).then((resultmsg) => {
                                sessionStorage.removeItem('cnpj');
                                location.href = window.location.href;
                            });

                        }
                    });
                }
                catch (error) {
                    parametrocnpj = null;
                }

            },

        }
    }
</script>